import * as React from "react";
const SvgFiRrCanFood = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12 0C8.286 0 2 .737 2 3.5c0 .01.004.019.004.029 0 .007-.004.013-.004.021V20.5C2 23.263 8.286 24 12 24c3.459 0 10-.742 10-3.55V3.5C22 .737 15.714 0 12 0m8 16.374C19.582 16.96 16.568 18 12 18s-7.577-1.009-8-1.578V9.736C6.159 10.691 9.609 11 12 11c2.248 0 5.79-.318 8-1.309zm0-9C19.582 7.96 16.568 9 12 9S4.423 7.991 4 7.422V5.736C6.159 6.691 9.609 7 12 7s5.841-.31 8-1.265zM12 2c4.746 0 7.396.986 7.937 1.5C19.395 4.014 16.746 5 12 5s-7.396-.986-7.937-1.5C4.604 2.986 7.254 2 12 2m0 20c-4.562 0-7.574-1.007-8-1.577v-1.687C6.159 19.691 9.609 20 12 20c2.248 0 5.79-.318 8-1.309v1.685c-.422.586-3.436 1.624-8 1.624"
    />
  </svg>
);
export default SvgFiRrCanFood;
